export default {
  schedule: {
    date_and_time: 'Data e ora*',
    number_of_guests: 'Numero di ospiti*',
    location: 'Posizione:',
  },
  personal_information: {
    title: 'Titolo',
    first_name: 'Nome',
    enter_first_name: 'Inserisci nome',
    last_name: 'Cognome*',
    enter_last_name: 'Inserisci cognome',
    email: 'Email',
    enter_email: 'Inserisci email',
    phone: 'Telefono',
    annotation: 'Annotazione',
    enter_annotation: 'Inserisci annotazione',
  },
  gender: {
    without_title: 'Senza titolo',
    male: 'Sig.',
    female: 'Sig.ra',
  },
  buttons: {
    save: 'Salva',
  },
  error_messages: {
    invalid_email: 'Inserisci un indirizzo email valido, senza spazi né dieresi prima della @.',
    invalid_phone_number: 'Numero di telefono non valido. Rivedi le informazioni e riprova.',
    failed_reservation: 'Invio della prenotazione non riuscito. Rivedi le informazioni e riprova.',
    invalid_reservation_day: 'Non accettiamo prenotazioni in questo giorno.',
    no_tables_available: 'Ci dispiace, non ci sono più tavoli disponibili.',
    please_enter_guests: 'Inserisci il numero di ospiti.',
    please_select_time: 'Seleziona un orario.',
    please_select_last_name: 'Inserisci il cognome',
  },
  success_messages: {
    reservation_saved: 'Prenotazione salvata con successo',
  },
};
